module.exports = __webpack_public_path__ + "img/F86B1DF9-BED5-428a-84BD-FBCCB78D9740.7505ef6c.png";